export var IconButtonStyles = function IconButtonStyles(props) {
  var theme = props.theme;

  if (!theme) {
    throw new Error('Theme is undefined or null.');
  }

  var palette = theme.palette;
  return {
    root: {
      backgroundColor: 'transparent',
      color: palette.themePrimary
    },
    rootHovered: {
      backgroundColor: palette.neutralLighter,
      color: palette.themeDarkAlt
    },
    rootPressed: {
      backgroundColor: palette.neutralLight,
      color: palette.themeDark
    },
    rootChecked: {
      backgroundColor: palette.neutralLight,
      color: palette.themeDark
    },
    rootDisabled: {
      backgroundColor: 'transparent',
      color: palette.neutralTertiary
    }
  };
};